module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ff611deb34bc9c097cb2ee3b16d35273.png";